// "Feedback" in the header tool row; opens the docked Feedback panel (a fixed sheet).
import { useState } from "react";
import { FeedbackPanel } from "./FeedbackPanel";

export function FeedbackButton({ projectId }: { projectId?: string | null }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className="btn btn--quiet" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        Feedback
      </button>
      {open ? <FeedbackPanel projectId={projectId} onClose={() => setOpen(false)} /> : null}
    </>
  );
}
